import {
  FC,
  FormEventHandler,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { ArrowLeft, Close, MagnifyingGlass } from 'svgIcons'
import Modal, { IFModalProps } from '@app.components/Modal/Modal'
import TextField from '@app.components/inputs/TextField'
import SelfIntroductionSearchResult from '@app.feature/coverletter/coverletter.manage/component/SelfIntroductionSearchResult'
import { openAlertModal } from '../AlertModal'

type SelfIntroductionSearchModalProps = IFModalProps

const SelfIntroductionSearchModal: FC<SelfIntroductionSearchModalProps> = ({
  onClose,
  ...props
}) => {
  const router = useRouter()
  const [input, setInput] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  const query = useMemo(() => {
    return `${router.query.q || ''}`
  }, [router.query])

  const handleSubmit: FormEventHandler = (e) => {
    e.preventDefault()
    inputRef.current?.blur()
    if (input === '') return
    if (input && input.trim().length < 2) {
      openAlertModal({
        open: true,
        message: '검색어는 2자 이상 입력하셔야합니다.',
        isModalOverlapping: true,
      })
      return
    }
    router.push({
      query: {
        ...router.query,
        back: router.query.back || router.asPath,
        q: input,
      },
    })
  }

  useEffect(() => {
    setInput(query)

    if (query === '') {
      inputRef.current?.focus()
    } else {
      inputRef.current?.blur()
    }
  }, [query])

  return (
    <Modal onClose={onClose} animation="left" {...props}>
      <StyledWrapper onSubmit={handleSubmit}>
        <div className="sticky">
          <div className="header">
            자기소개서 검색
            <ArrowLeft className="arrow-left" onClick={onClose} />
          </div>
          <div className="search-content">
            <div className="search-input-wrapper">
              <MagnifyingGlass onClick={handleSubmit} />
              <TextField
                value={input}
                ref={inputRef}
                placeholder="자기소개서 검색"
                className="search-input"
                onChange={(e) => setInput(e.target.value)}
              />
              {input && (
                <Close className="close" onClick={() => setInput('')} />
              )}
            </div>
          </div>
        </div>
        <SelfIntroductionSearchResult />
      </StyledWrapper>
    </Modal>
  )
}

export default SelfIntroductionSearchModal

const StyledWrapper = styled.form`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  background-color: #fafafa;
  .sticky {
    position: sticky;
    top: 0;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    font-size: 16px;
    font-weight: bold;
    background-color: #fff;
    .arrow-left {
      position: absolute;
      left: 20px;
      font-size: 16px;
    }
  }
  .search-content {
    padding: 10px 20px;
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
    .search-input-wrapper {
      padding: 8px 15px;
      display: flex;
      gap: 7px;
      align-items: center;
      background-color: #f4f4f4;
      border-radius: 5px;
      svg {
        width: 16px;
        height: 16px;
      }
      .close {
        font-size: 10px;
      }
      .search-input {
        background-color: transparent;
        padding: 0px;
        border: none;
        font-size: 16px;
        outline: none;
        border-radius: 0;
        &::placeholder {
          color: #bbb;
        }
      }
    }
  }
`
